import axios from 'axios';
import {refreshToken} from '../common/RefreshToken';

// Retry only authentication failures: replaying a POST after a validation or
// network error could create the same account/link twice.
export async function managementRequest(path = '/management', data, method = 'get', signal) {
  const send = () =>
    axios({
      method,
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/admin${path}`,
      data,
      signal,
      headers: {Authorization: `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)}`}
    });
  try {
    let response;
    try {
      response = await send();
    } catch (error) {
      if (error.response?.status !== 401 || signal?.aborted) throw error;
      await refreshToken();
      response = await send();
    }
    return response.data;
  } catch (error) {
    if (signal?.aborted || error.code === 'ERR_CANCELED') throw error;
    const failure = new Error(
      error.response?.data?.error ||
        'No se ha podido completar la operación. Comprueba la conexión y recarga los datos antes de reintentarlo.'
    );
    failure.fields = error.response?.data?.fields || {};
    throw failure;
  }
}
